import React from 'react';
import { Switch } from 'react-router-dom';
import Institutions from './institutions';
import Roles from './roles';
import Students from './students';
import Subjects from './subjects';
import Teachers from './teachers';
import Topics from './topics';
import Classes from './classes';
import SubjectsToTeacher from './bind-teachers';
import StudentsToSubject from './bind-students';
import AuthorizedPersons from './authorizedpersons';
import Groups from './groups';
import NotFound from '../../pages/error/not-found';
import Reports from './reports/index2';
import CheckExam from './check-exam';
import ExamResults from './exam-results';
import Exams from './create-exam';
import StudentsFile from './students-file';
import { RoleBasedRoute } from '../../components';

const ControlPanel = () => {
  return (
    <Switch>
      <RoleBasedRoute
        exact
        path="/control-panel/institutions"
        component={Institutions}
        roles={['admin']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/authorizedpersons"
        component={AuthorizedPersons}
        roles={['admin']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/teachers"
        component={Teachers}
        roles={['admin', 'director']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/students"
        component={Students}
        roles={['admin', 'director']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/classes"
        component={Classes}
        roles={['admin', 'director']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/subjects"
        component={Subjects}
        roles={['admin', 'director', 'teacher']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/topics"
        component={Topics}
        roles={['admin', 'director', 'teacher']}
      />
      <RoleBasedRoute exact path="/control-panel/groups" component={Groups} roles={['teacher']} />
      <RoleBasedRoute exact path="/control-panel/roles" component={Roles} roles={['admin']} />
      <RoleBasedRoute
        exact
        path="/control-panel/subjectsToTeachers"
        component={SubjectsToTeacher}
        roles={['director', 'teacher']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/studentsToSubjects"
        component={StudentsToSubject}
        roles={['director']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/createExam"
        component={Exams}
        roles={['teacher']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/reports"
        component={Reports}
        roles={['admin', 'director', 'teacher', 'student']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/checkExam"
        component={CheckExam}
        roles={['teacher']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/examResults"
        component={ExamResults}
        roles={['teacher','student']}
      />
      <RoleBasedRoute
        exact
        path="/control-panel/studentsFile"
        component={StudentsFile}
        roles={['admin', 'director']}
      />
      <RoleBasedRoute path="*" exact={true} component={NotFound} />
    </Switch>
  );
};

export default ControlPanel;
